

import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
 
@Injectable({
  providedIn: 'root'
})
export class CryptoService {
 
  private secretKey = 'Am_*127557dkfFGTF@FSDF93N__1Vass';
  private nonce = 'A2d(O_ms53$%5678';
 
  encrypt(data: any): string {
    const plaintext = JSON.stringify(data);
    const key = CryptoJS.enc.Utf8.parse(this.secretKey);
    const iv = CryptoJS.enc.Utf8.parse(this.nonce);
 
    const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
      iv: iv,
      mode: CryptoJS.mode.CTR,
      padding: CryptoJS.pad.NoPadding
    });
 
    return encrypted.toString();
  }
 
  decrypt(ciphertext: string): any {
    const key = CryptoJS.enc.Utf8.parse(this.secretKey);
    const iv = CryptoJS.enc.Utf8.parse(this.nonce);
 
    const decrypted = CryptoJS.AES.decrypt(ciphertext, key, {
      iv: iv,
      mode: CryptoJS.mode.CTR,
      padding: CryptoJS.pad.NoPadding
    });
 
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
   

    try {
      return JSON.parse(decryptedText);
    } catch (error) {
      return decryptedText;
  }  
    }
  }
 
